module.exports = __webpack_public_path__ + "media/images/home/our-purpose-img-bg-3bafb5039b473e3f34a3a3ee6e9b8868.jpg";